import { tsrestClient } from '@portal/provider/tsrest';

/**
 * Hook to check encryption status
 *
 * Returns encryption status information for determining portal routing
 */
export const useEncryptionStatus = () => {
  const statusQuery = tsrestClient.status.get.useQuery(
    ['system-status'],
    {},
    {
      refetchInterval: 30000, // Check every 30 seconds
      retry: 3,
      staleTime: 10000, // Consider data fresh for 10 seconds
    }
  );

  const encryptionStatus = statusQuery.data?.body.encryption;

  return {
    encryptionStatus,
    isLoading: statusQuery.isLoading,
    error: statusQuery.error,
    refetch: statusQuery.refetch,
    // Helper to check if encryption is ready
    isEncryptionReady: encryptionStatus?.status === 'ready',
    // Helper to check if we should show encryption setup
    shouldShowEncryptionSetup: encryptionStatus?.status !== 'ready',
    // Helper to check if we have missing key file with encrypted data
    hasMissingKeyFileWithData: encryptionStatus?.status === 'missing_with_data',
    // Helper to force refetch status (useful after key generation)
    forceRefetch: () => {
      statusQuery.refetch();
    },
  };
};
